import {typesFSCPAGE} from '../redux/svtypes/fscpageTypes'

let initStore = {
    loading: false,
    error: false,
    radio_data: [
        {
            "name": "1",
            "id": 1,
            "selected": true,
            "age": 23,
            "species": "T. Rex"
        },
        {
            "name": "2",
            "id": 2,
            "selected": false,
            "age": 44,
            "species": "Bracchio"
        },
        {
            "name": "3",
            "id": 3,
            "selected": false,
            "age": 32,
            "species": "Stego"
        },
        {
            "name": "4",
            "id": 4,
            "selected": false,
            "age": 13,
            "species": "T. Rex"
        }
    ],
    my_data: [
        {
            "name": "Bob",
            "age": 23,
            "species": "T. Rex"
        },
        {
            "name": "Dylan",
            "age": 44,
            "species": "Bracchio"
        },
        {
            "name": "Kate",
            "age": 32,
            "species": "Stego"
        },
        {
            "name": "Sally",
            "age": 13,
            "species": "T. Rex"
        }
    ],
    filters: {
                
        all: [], // Contains the full data
        //"startDate": "2024-07-22T23:42:55.795+00:00" ,
       // "endDate": "2024-07-22T25:42:55.795+00:00" ,
       startDate : new Date(),
       endDate : new Date(),
       esqueryAdults:"t1",
       esqueryChilds:"m1",
       esqueryInfants:"i0",
       esqueryCabin:"ECONOMY",
       esqueryTripType:"roundtrip",
       
       esqueryText: '',
       esqueryDestText: '',
       dataSourceSV : ['Burns Bay Road', 'Downing Street', 'Wall Street'],
    
      
        key: 'selection',
        "hotelsSelected":{"value": "kenServer", "label": "kenServer"},
        hotels: {
            
            options:[
                { value: 'jen', label: 'jen1Server' },
                { value: 'ken', label: 'ken1Server' },
                { value: 'ben', label: 'ben1Server' }
            ],
            values: { value: 'ken', label: 'ken1Server' }
    },
        HOTEL_DEST: {
            id: "HOTEL_DEST_STATUS", 
            defaultOptions: [], 
            options: [],
            label: "Hptel Location",
            values: [],
            showing: []

        },
        HOTEL_DATE_RANGE: {
           
                startDate: new Date(),
                endDate: new Date(),
           
            key: 'selection'
            
        },
        APP_OPERATIONAL_STATUS:{
            id: "APP_OPERATIONAL_STATUS", 
            defaultOptions: [], 
            options: [],
            label: "Status",
            values: [],
            showing: []
        },
        
        APPLICATION_NAME: {
            id: "APPLICATION_NAME",
            defaultOptions: [],
            options: [],
            label: "Applications",
            values: [],
            showing: []
        }
      
    }
}

export default (state = initStore, action) => {
    console.log(action);
    let januState;
    switch (action.type) {
        case  "fscpage-success":
            console.log("action type fscpage success");
            console.log(action.payload.my_data);
            // let januState = {...state, loading: false, my_data: action.payload.my_data}
             januState = {...state, loading: false, my_data: action.payload.my_data}
            return januState
        case "fscpageradio-success":
                console.log("action type fscpageradio success");
                console.log(action.payload.my_data);
                // let januState = {...state, loading: false, my_data: action.payload.my_data}
                 januState = {...state, loading: false, radio_data: action.payload.radio_data}
                return januState
        case typesFSCPAGE.GET_FSCPAGE_DATA_BEGIN:
            console.log("loading")
            return {...state, loading: true}
        case typesFSCPAGE.GET_FSCPAGE_DATA_ERROR:
            console.log("error")
            return {...state, error: true}
    }
}